<!-- @TODO: reuse dialog-confirm -->
<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title class="dialog-title">{{ notification.title }}</h2>
    <button mat-dialog-close matIconButton aria-label="Close dialog" (click)="closeOnce()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <p [innerHTML]="notificationBody"></p>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button matButton="outlined" (click)="closeOnce()">Show again next time</button>
    <button matButton="filled" (click)="closeDefinitively()">Okay, don't tell me again</button>
  </mat-dialog-actions>
</div>
